<template>
  <!-- @drop.prevent.stop="handleDrop" this STOP requires to stop bubbling to not call @drop on the parent element -->
  <li
    class="list-group-item d-flex justify-content-between align-items-center"
    draggable="true"
    style="cursor:pointer;"
    @dragstart="dragStart"
    @dragover.prevent
    @drop.prevent.stop="handleDrop"
  >
    <span class="mr-2 font-size-md">{{ seq }}</span>
    <img
      v-if="wonPrize.imageUrl"
      :src="wonPrize.imageUrl"
      alt=""
      class="rounded mr-2"
      style="width:50px; height:50px; object-fit:cover; cursor:pointer;"
      @click="openImage"
    />
    <div
      class="flex-grow-1 mr-2 ml-1"
      data-toggle="tooltip"
      :title="displayTitle"
      :data-original-title="displayTitle"
    >
      {{ truncatedTitle }} <span v-if="wonPrize.fdaEntryRequired" class="badge badge-warning text-white ml-1">FDA</span>
      <br />
      <small class="ml-2 text-muted">SKU: {{ wonPrize.sku }}</small>
    </div>
    <button class="btn btn-sm btn-outline-danger ml-1" @click.prevent="confirmDelete()"
            aria-label="Delete this item">
      <i class="ri-close-line"></i>
    </button>
  </li>
  <div
    v-if="showModal"
    class="image-modal-overlay"
    @click="closeModal"
  >
    <img :src="wonPrize.imageUrl" alt="Full size" />
  </div>
</template>

<style scoped>
.image-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.image-modal-overlay img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 0.25rem;
}
</style>

<script>
export default {
  inject: ['i18n'],
  props: {
    wonPrize: { type: Object, required: true },
    boxId: { type: [String, Number], required: true },
    seq: { type: Number, required: true }
  },
  data() {
    return {
      t: (key, options) => this.i18n.t(key, options),
      showModal: false
    }
  },
  computed: {
    displayTitle() {
      return this.i18n.locale === 'jp' && this.wonPrize.japaneseTitle
        ? this.wonPrize.japaneseTitle
        : this.wonPrize.title
    },
    truncatedTitle() {
      const displayLength = this.i18n.locale === 'jp' && this.wonPrize.japaneseTitle ? 25 : 40
      const txt = this.displayTitle
      return txt.length > displayLength
        ? txt.slice(0, displayLength) + '…'
        : txt
    }
  },
  methods: {
    openImage() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    dragStart(event) {
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/plain', JSON.stringify({ itemId: this.wonPrize.id, fromBoxId: this.boxId }))
    },
    handleDrop(event) {
      const data = event.dataTransfer.getData('text/plain')
      if (!data) return
      const { itemId, fromBoxId } = JSON.parse(data)
      this.$emit('drop-item', {
        itemId,
        fromBoxId,
        toBoxId: this.boxId,
        targetItemId: this.wonPrize.id
      })
    },
    confirmDelete() {
      if (confirm(this.t('features.input_packing.confirm_delete'))) {
        this.$emit('delete-item', { boxId: this.boxId, itemId: this.wonPrize.id })
      }
    }
  }
}
</script>
